/**
 * Helper pur — politique de mot de passe Kollectivia.
 *
 * Politique MVP (validée Chunk 7.C, alignée NIST SP 800-63B révisée 2024) :
 *  - longueur minimale **12 caractères** (après trim)
 *  - **différent de l'email** (case-insensitive)
 *
 * Pas d'exigence de composition (pas de "1 majuscule + 1 chiffre + 1 spécial")
 * — ces règles dégradent la sécurité réelle (poussent vers patterns
 * prédictibles type `Password1!`).
 *
 * Les codes retournés sont des **codes machine** (pas des phrases).
 * L'UI traduit via `t('errors.password.' + code)` pour rester multilingue
 * sans coupler le helper à une langue.
 */

export type PasswordError = "too_short" | "equals_email";

export type PasswordValidationResult =
  | { ok: true; errors: [] }
  | { ok: false; errors: PasswordError[] };

const MIN_LENGTH = 12;

/**
 * Valide un mot de passe selon la politique MVP.
 *
 * @param password Mot de passe brut saisi par l'utilisateur.
 * @param email    Optionnel — pour vérifier la non-égalité.
 */
export function validatePassword(password: string, email?: string): PasswordValidationResult {
  const trimmed = password.trim();
  const errors: PasswordError[] = [];

  if (trimmed.length < MIN_LENGTH) {
    errors.push("too_short");
  }

  if (email && trimmed.length > 0 && trimmed.toLowerCase() === email.trim().toLowerCase()) {
    errors.push("equals_email");
  }

  if (errors.length === 0) {
    return { ok: true, errors: [] };
  }
  return { ok: false, errors };
}

/**
 * Constante exposée pour l'UI (texte aide / placeholder).
 */
export const PASSWORD_MIN_LENGTH = MIN_LENGTH;
